


import { combineReducers } from 'redux'
import { authReducer } from './authReducer'
import { productReducer } from './productReducer'
import { sellReducer } from './sellReducer'
import { uiReducer } from './uiReducer'


export const rootReducer = combineReducers({
    ui: uiReducer,
    auth: authReducer,
    productsDB: productReducer,
    sell: sellReducer
})